import React, { useContext, useState } from 'react'
import { BottomDiv, ButtonContainer, ButtonDiv, CloseDiv, Container, DimensionDiv, FormData, Header, InputData, InputDiv, InputLabel } from './style'
import ModalContext from '../../../../contexts/ModalContext'
import close from '../../../../assets/close-icon.svg'
import { ServicesContext } from '../../../../contexts/ServicesContext'

const DimensionsModal:React.FC = () => {
  const [ length, setLength ] = useState('')
  const [ dim1, setDim1 ] = useState('')
  const [ dim2, setDim2 ] = useState<null | string>(null)
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { setService, service } = useContext(ServicesContext)
  
  return(
    <Container>
      <Header>
      <h2>Inserir dimensões: {service.format.charAt(0).toUpperCase() + service.format.slice(1)}</h2>
      <CloseDiv onClick={() => setModalActive(false)}>
          <img src={close} />
        </CloseDiv>
      </Header>
        <FormData>
          <DimensionDiv>
            <h4>Dimensão de partida (mm)</h4>
            <InputDiv>
              <InputLabel>Largura</InputLabel>
              <InputData 
                value={dim1}
                onChange={(e) => setDim1(e.target.value)}
              />
            </InputDiv>
            {dim2 ? (
              <InputDiv>
                <InputLabel>Diâmetro externo</InputLabel>
                <InputData 
                  value={length}
                  onChange={(e) => setDim2(e.target.value)}
                />
              </InputDiv>
            ) : null}
            <InputDiv>
              <InputLabel>Comprimento</InputLabel>
              <InputData 
                value={length}
                onChange={(e) => setLength(e.target.value)}
              />
            </InputDiv>
          </DimensionDiv>
        </FormData>
        <BottomDiv>
          <span></span>
          <ButtonContainer>
            <ButtonDiv onClick={(() => setModalSection('createService'))} className='cancel'>Voltar</ButtonDiv>
            <ButtonDiv onClick={() => {
              if(dim2 !== null && dim2 !== '') 
              setService({
                ...service,
                startingDimension:[dim1, length]
              })
            }}>Salvar</ButtonDiv>
          </ButtonContainer>
        </BottomDiv>
    </Container>
  )
}

export default DimensionsModal